var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"45px !important"},attrs:{"src":require("@/assets/images/app/logo_heyway_koksgrå_rgb.png"),"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }